const amt_admin = require('amt_admin').default;
const app = require('angular').module('ww2_analytics.gold', [amt_admin]);

const paid_template = require('./paid.html');
const free_template = require('./free.html');
const total_template = require('./total.html');


app.config([
  '$stateProvider',
  function($stateProvider) {
    $stateProvider.state('amt.ww2.gold', {
      url: '/gold',
      abstract: true,
      template: '<div class="row" ui-view></div>',
      data: {
        priority: 801,
        title: 'Gold',
        role: 'gold'
      },
      menu: {
        glyphicon: 'stats',
        childs: [
            {
              state: 'amt.ww2.gold.total',
              glyphicon: 'stats'
            },
            {
              state: 'amt.ww2.gold.paid',
              glyphicon: 'stats'
            },
            {
              state: 'amt.ww2.gold.free',
              glyphicon: 'stats'
            },
        ]
    }
    })
    .state('amt.ww2.gold.total', {
        url: '/total',
        template: total_template,
        reloadOnSearch: false,
        data: {
            priority: 801,
            title: 'Total',
            role: 'gold'
        }
    })
    .state('amt.ww2.gold.paid', {
        url: '/paid',
        template: paid_template,
        reloadOnSearch: false,
        data: {
            priority: 801,
            title: 'Paid',
            role: 'gold'
        }
    })
    .state('amt.ww2.gold.free', {
        url: '/free',
        template: free_template,
        reloadOnSearch: false,
        data: {
            priority: 801,
            title: 'Free',
            role: 'gold'
        }
    })
  }
]);

export default app.name;
